import React from 'react'
import baseStyles from './Base.module.css'
import PageStatus from '../PageStatus'
import Student from '../Student'
import { isHeg } from '../lib/utils'
import { Link } from '@reach/router'

export default ({ path }) => {
    const { student } = Student.useContainer()
    return (
        <div className={baseStyles.root}>
            {isHeg(student) ? (
                <>
                    <p>
                        <h2>Auto-contrôle des prérequis en mathématiques</h2>
                        <PageStatus path={path} label="J'ai effectué l'auto-évaluation en math" />
                        La HEIG-VD a développé un outil d’auto-évaluation en mathématiques servant d’indication quant à la
                        nécessité ou non d’améliorer votre niveau avant la rentrée :
                    </p>
                    <p>
                        <a
                            href="https://cyberlearn.hes-so.ch/course/view.php?id=15955"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Auto-évaluation en math
                        </a>{' '}
                    </p>
                    <p>
                        <strong>
                            Se connecter avec l’établissement HES-SO – Haute école spécialisée de Suisse occidentale. Utilisez
                            ensuite votre identifiant et mot de passe edu-ID.
                        </strong>{' '}
                    </p>
                    <p>
                        Commencez par le « test d’évaluation préalable » (obligatoire), puis vous pouvez utiliser autant de fois
                        que vous le souhaitez les autres tests.
                    </p>
                    <p>
                        En complément, la HEIG-VD organise avant la rentrée, des{' '}
                        <Link to="/2026/cours-preparatoires">cours préparatoires</Link>{' '}
                        auxquels vous pouvez vous inscrire dans la section dédiée.
                    </p>
                    <h3>Autres ressources</h3>
                    <p>
                        Pour celles et ceux qui souhaitent effectuer une mise à niveau en autodidacte, le{' '}
                        <strong>MOOC HES-SO</strong> «{' '}
                        <a
                            href="https://numerique.hes-so.ch/?redirect=0&cid=161"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Vous reprendrez bien un peu de maths ?
                        </a>{' '}
                        » de Titienne Bitschnau est à disposition. Ce cours en ligne aborde en vidéo les bases du calcul
                        littéral et de la résolution d’équations (puissances, racines, polynômes, équation du 1er et du
                        2ème degré, exponentielles et logarithmes, etc.). Des vidéos, des exercices corrigés, des quiz
                        d’évaluation et de validation font de ce cours un excellent moyen de préparer votre rentrée.
                        L’inscription est gratuite et possible en tout temps.
                    </p>
                </>
            ) : (
                <>
                    <h2>Autoévaluation des prérequis en mathématiques</h2>
                    <PageStatus path={path} label="J'ai effectué l'auto-évaluation en math" />
                    <p>
                        <strong>
                            Pourquoi devez-vous effectuer cette autoévaluation ?
                        </strong>{' '}
                    </p>
                    <p>
                        Deux étudiants vous l’expliquent dans cette vidéo.
                    </p>
                    <video controls style={{ maxWidth: '100%' }}>
                        <source src={`${process.env.PUBLIC_URL}/videos/unite-preparatoire-v3.mp4`} type="video/mp4" />
                        Votre navigateur ne supporte pas la lecture vidéo.
                    </video>
                    <p>
                        <a
                            href="https://cyberlearn.hes-so.ch/enrol/index.php?id=42409"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Auto-évaluation en math
                        </a>{' '}
                    </p>
                    <p>
                        <strong>
                            Se connecter avec l’établissement HES-SO – Haute école spécialisée de Suisse occidentale. Utilisez ensuite votre identifiant et mot de passe edu-ID.
                        </strong>{' '}
                    </p>
                    <p>
                        Effectuez le test en 4 parties dans l'onglet "Autoévaluation", en suivant les indications fournies. Puis, selon votre score, vous pouvez exploiter les ressources de révisions autonomes mises à disposition dans l'onglet du même nom, voire vous inscrire à <Link to="/2026/inscription-unites-preparatoires">l'unité préparatoire</Link> de mathématiques.
                    </p>
                </>
            )}
        </div>
    )
}
